// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"125": "cf91006d","354": "b478a622","535": "19b42169","636": "db35f366","878": "cb8c228c","971": "63f20326",}[chunkId] + ".js"
}